import { ARTICLE_TEXT, articleCount } from "../../views/artikel/articleTexts.js";

/**
 * Die Anwendertexte des Artikel-Dialogs und der Kategorienpflege (Spec Artikelmodul 0.4, „Texte“): englische Schlüssel,
 * deutsche Werte. Der Tipp zu „Konto fehlt“ (786) und die Takt- und Laufzeitwörter stehen EINMAL in articleTexts.ts
 * und werden hier nur benutzt — Kachel und Dialog sagen dasselbe mit demselben Satz.
 */
export const ARTICLE_DIALOG_TEXT = {
  titleNew: "Neuer Artikel",
  titleEdit: (nummer: string): string => `Artikel ${nummer} bearbeiten`,
  /** Der Pfad über dem Kopf: „Artikel › Kategorie“ bzw. „neu im Unternehmen ME“. */
  pathEdit: (kategorie: string): string => `${ARTICLE_TEXT.area} › ${kategorie}`,
  pathNew: (kuerzel: string): string => `neu im Unternehmen ${kuerzel}`,
  /** Die Erklärung unter dem Titel (123, Entscheid Controller 6; 722, 783) — einmal für den ganzen Dialog. */
  explanation: "Ein Artikel ist die Vorlage für Positionen in Angeboten, Aufträgen und Rechnungen. Preis und Steuer "
    + "übernehmen neue Positionen, maßgeblich bleibt die Position. Laufzeit und Takt sind Vorgaben für neue Vorgänge "
    + "und werden noch nicht automatisch übernommen.",
  sectionMaster: "Stammdaten",
  sectionPrice: "Preis & Steuer",
  sectionTerms: "Konditionen",
  company: "Unternehmen",
  productNumber: "Artikelnummer",
  name: "Name",
  category: "Kategorie",
  inactive: "Stillgelegt",
  /** Der Schaltertext nennt die Wirkung (131). */
  inactiveEffect: "Für neue Positionen nicht mehr wählbar",
  description: "Beschreibung",
  price: "Preis netto",
  taxRate: "Steuersatz",
  /** „Konto (SKR04)“ — der Kontenrahmen des Unternehmens, sobald die Konten geladen sind. */
  account: (rahmen: string | null): string => (rahmen === null ? "Konto" : `Konto (${rahmen})`),
  costCentre: "Kostenstelle",
  billingSource: "Abrechnungsquelle",
  billingCycle: "Abrechnungstakt",
  term: "Vorgabe-Laufzeit",
  priceUnitLabel: "Einheit des Preises",
  termUnitLabel: "Einheit der Vorgabe-Laufzeit",
  /** Die Einheit im Preisfeld (126): „€/Monat“. */
  pricePerUnit: (einheit: string): string => `€/${einheit}`,
  /** Der Steuersatz im Feld: „19 %“ (bei zwei Sätzen gleicher Höhe mit ihrem Beginn). */
  ratePercent: (satz: string): string => `${satz} %`,
  rateFrom: (satz: string, ab: string): string => `${satz} % ab ${ab}`,
  /** Die Hilfe am Steuersatz: „Regelsatz, brutto 224,91 €/Monat“ (ohne Preis nur der Satzname). */
  taxHelp: (name: string, brutto: string | null): string => (brutto === null ? name : `${name}, brutto ${brutto}`),
  withoutCategory: ARTICLE_TEXT.withoutCategory,
  noAccount: "kein Konto",
  noCostCentre: "ohne",
  /** Die leere Abrechnungsquelle heißt „von Hand“, damit `schmal` reicht. */
  manual: "von Hand",
  sourceMonitor: "Monitor",
  sourceAircall: "Aircall",
  noCycle: "ohne",
  /** Ein gespeicherter Wert, der nicht mehr zur Auswahl steht (stillgelegt, abgelöst). */
  previousEntry: "bisheriger Eintrag",
  numberSuggested: "Vorschlag aus dem Nummernkreis, änderbar",
  numberNoRange: "Kein Nummernkreis für Artikel eingerichtet (Verwaltung › Nummernkreise).",
  numberUnique: "Eindeutig im Unternehmen.",
  /** Nach 422 `NUMMER_VERGEBEN` (P6): der neue Vorschlag als Hilfe. */
  numberNewSuggestion: (nummer: string): string => `Neuer Vorschlag aus dem Nummernkreis: ${nummer}`,
  descriptionHelp: "Der erste Absatz ist der Kurztext der Kachel, eine Leerzeile trennt Absätze.",
  previewTitle: "Kurztext auf der Kachel",
  termHelp: "Leer lassen, wenn es keine Vorgabe gibt.",
  /** „Konto fehlt“ als Warnung am Feld Konto (786, 128) — derselbe Satz wie der Tipp an der Kachel. */
  missingAccountWarning: ARTICLE_TEXT.missingAccountTip,
  // Prüfung in der Maske (die Fachprüfung macht der Server)
  numberMissing: "Bitte eine Artikelnummer eintragen.",
  nameMissing: "Bitte einen Namen eintragen.",
  priceMissing: "Bitte einen Preis eintragen.",
  priceInvalid: "Bitte einen Preis ab 0 mit höchstens zwei Nachkommastellen eintragen.",
  taxRateMissing: "Bitte einen Steuersatz wählen.",
  unitMissing: "Bitte eine Einheit wählen.",
  termInvalid: "Die Laufzeit muss eine ganze Zahl von 1 bis 600 sein.",
  // Rückfragen und Quittungen
  confirmSave: "Änderungen am Artikel speichern?",
  changed: (felder: readonly string[]): string => `Geändert: ${felder.join(", ")}.`,
  confirmCreate: "Neuen Artikel anlegen?",
  createConsequence: (nummer: string, name: string, kuerzel: string): string =>
    `${nummer} · ${name} wird im Unternehmen ${kuerzel} angelegt.`,
  yes: "Ja",
  no: "Nein",
  noChanges: "Keine Änderungen.",
  conflict: "Der Artikel wurde inzwischen geändert.",
  reloadGone: "Den Artikel gibt es nicht mehr.",
  save: "Speichern",
  cancel: "Abbrechen",
  loading: "Lädt …",
  loadError: "Die Vorgaben des Artikels konnten nicht geladen werden. Bitte den Dialog schließen und neu öffnen.",
  // Stilllegen per ⋯ an der Kachel
  confirmDeactivate: (nummer: string): string => `Artikel ${nummer} stilllegen?`,
  deactivateConsequence: "Er erscheint dann nicht mehr in der Artikelsuche neuer Positionen. Bestehende Angebote und "
    + "Aufträge bleiben unverändert.",
  confirmActivate: (nummer: string): string => `Artikel ${nummer} wieder aktivieren?`,
  activateConsequence: "Er erscheint dann wieder in der Artikelsuche neuer Positionen.",
  deactivate: "Stilllegen",
  activate: "Wieder aktivieren",
  /** RF4: der Stand an der Kachel war veraltet — der Katalog wird neu geladen. */
  staleReloaded: "Der Artikel wurde inzwischen geändert. Die Artikel sind neu geladen, bitte erneut wählen.",
  actionFailed: "Das hat nicht geklappt. Bitte erneut versuchen.",
} as const;

/** Die Namen der Felder in „Geändert: …“ (Rückfrage beim Speichern) — kurz, in der Reihenfolge des Formulars. */
export const CHANGED_FIELD_TEXT = {
  productNumber: "Artikelnummer", name: "Name", productCategoryId: "Kategorie", active: "Stillgelegt",
  description: "Beschreibung", netUnitPrice: "Preis", unitOfMeasureId: "Einheit", taxRateId: "Steuersatz",
  bookingAccountId: "Konto", costCentreId: "Kostenstelle", billingDataSource: "Abrechnungsquelle",
  defaultBillingCycle: "Abrechnungstakt", defaultTerm: "Vorgabe-Laufzeit",
} as const;

/** Die Texte der Kategorienpflege (776). */
export const CATEGORY_CARE_TEXT = {
  title: (kuerzel: string): string => `Kategorien von ${kuerzel}`,
  listLabel: "Kategorien in ihrer Reihenfolge",
  name: (n: number): string => `Name der Kategorie ${n}`,
  usage: articleCount,
  up: (name: string): string => `${name} nach oben`,
  down: (name: string): string => `${name} nach unten`,
  move: (name: string): string => `${name} verschieben`,
  remove: (name: string): string => `${name} löschen`,
  removeText: "Löschen",
  /** Der Ziehgriff und die Pfeile — Zeichen, keine Wörter; die Namen stehen im `aria-label`. */
  grip: "⠿",
  upSymbol: "▲",
  downSymbol: "▼",
  nameMissing: "Bitte einen Namen für die Kategorie eintragen.",
  /** Name einer noch nicht gespeicherten Kategorie in Ansagen und Knopfnamen. */
  unnamed: "neue Kategorie",
  newCategory: "Neue Kategorie",
  empty: "Es gibt noch keine Kategorien.",
  /** Die Rückfrage nennt, was geschieht: „Reihenfolge und 2 Namen ändern, 1 Kategorie anlegen?“ */
  confirm: (teile: { order: boolean; renamed: number; created: number; deleted: number }): string => {
    const aendern = [
      ...(teile.order ? ["Reihenfolge"] : []),
      ...(teile.renamed > 0 ? [`${teile.renamed} Namen`] : []),
    ];
    const saetze = [
      ...(aendern.length > 0 ? [`${aendern.join(" und ")} ändern`] : []),
      ...(teile.created > 0 ? [`${teile.created} ${teile.created === 1 ? "Kategorie" : "Kategorien"} anlegen`] : []),
      ...(teile.deleted > 0 ? [`${teile.deleted} ${teile.deleted === 1 ? "Kategorie" : "Kategorien"} löschen`] : []),
    ];
    return `${saetze.join(", ")}?`;
  },
  confirmText: "Die Kategorien werden in dieser Reihenfolge geschrieben: neue anlegen, Namen ändern, Reihenfolge, "
    + "leere löschen.",
  /** Ein Fehler stoppt die Reihe: was schon geschrieben ist, und was nicht mehr. */
  loadError: "Die Kategorien konnten nicht geladen werden.",
} as const;
